/** A `Storage`-shaped adapter over localStorage that never throws (private mode, blocked data). */
export const safeLocalStorage: Pick<Storage, 'getItem' | 'setItem'> = {
  getItem(key) {
    try {
      return globalThis.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      globalThis.localStorage.setItem(key, value);
    } catch {
      // Ignore: layout just won't persist.
    }
  },
};
